import {loadScript} from '@opten/script/load-script';

export class RecaptchaValidator {

	private $captcha: JQuery;
	private $form: JQuery;
	private $textarea: JQuery;

	constructor(private element: HTMLElement) {
		this.$captcha = $(element);
		this.$form = this.$captcha.closest('form');

		let scriptUrl = '//www.google.com/recaptcha/api.js?render=explicit&onload=recaptchaOnLoadCallback';
		const culture = this.$captcha.data('hl');
		if(culture){
			scriptUrl += '&hl=' + culture;
		}

		loadScript(scriptUrl)
			.catch((exc) => console.error('catch', exc));

		window.recaptchaOnLoadCallback = () => {
			this.init();
		};
	}

	private init() {
		grecaptcha.render(this.$captcha[0], {
			callback: (response) => this.callback(response),
			sitekey: this.$captcha.data('sitekey')
		});

		this.$textarea = $('#g-recaptcha-response');

		this.$textarea
			.attr('data-val-required', this.$captcha.data('message'))
			.attr('data-val', 'true')
			.attr('required', 'required')
			.attr('readonly', 'readonly')
			.css({
				'display': 'block',
				'height': '0px',
				'width': '0px',
				'border': 'none',
				'margin': '0'
			});

		this.updateForm();

		this.$form.on('submit', e => {
			const response = grecaptcha.getResponse();

			if (response.length === 0) {
				return false;
			} else {
				return true;
			}
		});
	}

	private callback(response) {
		this.$textarea.valid();
		this.updateForm();
	}

	private updateForm() {
		this.$form.removeData('validator');
		this.$form.removeData('unobtrusiveValidation');
		$.validator.unobtrusive.parse(this.$form);
	}
}